// extracted by mini-css-extract-plugin
export default {"checkWrapper":"Step3_checkWrapper__sknfU","check":"Step3_check__rxbzi","checkText":"Step3_checkText__I+Pul","rButton":"Step3_rButton__IRYI2"};